module.exports = __webpack_public_path__ + "static/media/level-5.8ebd607d.png";